import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Email = (props) => (
  <SvgIcon {...props} viewBox="0 0 22 18">
    <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.871948" y="0.5" width="20.2999" height="16.2428" stroke="currentColor" />
      <path d="M1 0.395996L11 10.396L21 0.395996" stroke="currentColor" />
    </svg>
  </SvgIcon>
);

export default Email;
